import { apiFetch } from './client';

export const getStigSummary   = (systemId) => apiFetch(`/stig/summary?system_id=${systemId}`);
export const getLibraryStatus = (systemId) => apiFetch(`/stig/library-status?system_id=${systemId}`);
